export const flagNames = Object.freeze({
  de: "Deutsch",
  es: "Español",
  fr: "Français",
  gb: "English",
  it: "Italiano",
  nl: "Nederlands",
});
